module.exports = __webpack_public_path__ + "static/media/Avenir-Light.c888326f.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Avenir-Light.ttf
// module id = 999
// module chunks = 0 1 2 4 5 6 9 18 19 20 21